import {createSlice} from '@reduxjs/toolkit';
import {initialLidState} from './initialLidState';
import {setIntermediateCeiling} from "../intermediateCeiling/intermediateCeilingSlice";


const lidSlice = createSlice({
    name: 'lid',
    initialState: null,
    reducers: {
        setLid: (state) => state || initialLidState,
        unsetLid: () => null,
        setFirmHeight: (state, action) => {
            const {type, collar} = state;
            if (type === 'subfloor' || collar === 'without') return;
            const {height} = action.payload;

            state.firmHeight = height;
        },
        unsetFirmHeight: (state) => {
            const {firmHeight: _removed, ...stateWithoutFirmHeight} = state;

            return stateWithoutFirmHeight;
        },
        setLidType: (state, action) => {
            const {type} = action.payload;
            if (state.type !== type) {
                if (type === 'subfloor') {
                    return {
                        type,
                        manholes: [],
                        blockOuts: [],
                        circularBlockOuts: []
                    };
                }
                if (type === 'A15') {
                    return {
                        type,
                        collar: 'beveled',
                        fill: 'concretegray',
                        manholes: [],
                        blockOuts: [],
                        circularBlockOuts: []
                    };
                }
                return {
                    type,
                    collar: 'beveled',
                    fill: 'anthracite',
                    manholes: [],
                    blockOuts: [],
                    circularBlockOuts: []
                };
            }
            return state;
        },
        setLidCollar: (state, action) => {
            const {collar} = action.payload;

            if (state.collar !== collar) {
                state.collar = collar;
                state.fill =
                    collar === 'pavingready'
                        ? state.type === 'B125'
                            ? 'partialfill'
                            : 'without'
                        : collar === 'lifted' || state.type === 'A15'
                            ? 'concretegray'
                            : 'anthracite';
                state.blockOuts = [];
                state.circularBlockOuts = [];
                if (collar === 'without') {
                    delete state.firmHeight;
                }
            }
        },
        setLidFill: (state, action) => {
            const {fill} = action.payload;

            state.fill = fill;
        },
        // Manholes reducers
        addManhole: (state, action) => {
            const {manhole} = action.payload;

            state.manholes.push(manhole);
        },
        removeManhole: (state, action) => {
            const {id} = action.payload;

            state.manholes = state.manholes.filter(manhole => manhole.id !== id);
        },
        moveManhole: (state, action) => {
            const {id, x, y} = action.payload;

            state.manholes = state.manholes.map(manhole => {
                if (manhole.id !== id) return manhole;
                return {...manhole, x, y};
            });
        },
        resizeManhole: (state, action) => {
            const {id, width, height} = action.payload;

            state.manholes = state.manholes.map(manhole => {
                if (manhole.id !== id) return manhole;
                return {...manhole, width, height};
            });
        },
        // BlockOuts reducers
        addBlockOut: (state, action) => {
            const {blockOut} = action.payload;

            state.blockOuts.push(blockOut);
        },
        removeBlockOut: (state, action) => {
            const {id} = action.payload;

            state.blockOuts = state.blockOuts.filter(
                blockOut => blockOut.id !== id
            );
        },
        moveBlockOut: (state, action) => {
            const {id, x, y} = action.payload;

            state.blockOuts = state.blockOuts.map(blockOut => {
                if (blockOut.id !== id) return blockOut;
                return {...blockOut, x, y};
            });
        },
        resizeBlockOut: (state, action) => {
            const {id, width, height} = action.payload;

            state.blockOuts = state.blockOuts.map(blockOut => {
                if (blockOut.id !== id) return blockOut;
                return {...blockOut, width, height};
            });
        },
        // Circular BlockOuts reducers
        addCircularBlockOut: (state, action) => {
            const {blockOut} = action.payload;

            state.circularBlockOuts.push(blockOut);
        },
        removeCircularBlockOut: (state, action) => {
            const {id} = action.payload;

            state.circularBlockOuts = state.circularBlockOuts.filter(
                blockOut => blockOut.id !== id
            );
        },
        moveCircularBlockOut: (state, action) => {
            const {id, x, y} = action.payload;

            state.circularBlockOuts = state.circularBlockOuts.map(blockOut => {
                if (blockOut.id !== id) return blockOut;
                return {...blockOut, x, y};
            });
        },
        resizeCircularBlockOut: (state, action) => {
            const {id, diameter} = action.payload;

            state.circularBlockOuts = state.circularBlockOuts.map(blockOut => {
                if (blockOut.id !== id) return blockOut;
                return {...blockOut, diameter, outerDiameter: diameter};
            });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(setIntermediateCeiling, (state) => {
                if (!!state) {
                    state.blockOuts = [];
                    state.circularBlockOuts = [];
                    state.manholes = [];
                }
            }
        );
    }
})

export const {
    setLid,
    unsetLid,
    setFirmHeight,
    unsetFirmHeight,
    setLidType,
    setLidCollar,
    setLidFill,
    addManhole,
    removeManhole,
    moveManhole,
    resizeManhole,
    addBlockOut,
    removeBlockOut,
    moveBlockOut,
    resizeBlockOut,
    addCircularBlockOut,
    removeCircularBlockOut,
    moveCircularBlockOut,
    resizeCircularBlockOut
} = lidSlice.actions

export default lidSlice.reducer